import { pick } from "../../util/object";
import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";

export interface Banner {
  id: number;
  titleId: number;
  image: string;
  url: string;
}

export function apiBannerGet(): AxiosPromise<Banner[]> {
  return $httpAdmin.get('/title/mtrotationselect');
}

export async function apiBannerAdd(params: Omit<Banner, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtrotationadd', params);
  return $httpAdmin.post('/title/mtrotationadd', params);
}

export async function apiBannerUpdate(params: Partial<Banner>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/title/mtrotationupdate', pick(params, ['id', 'image']));
  return $httpAdmin.patch('/title/mtrotationupdate', params);
}

export async function apiBannerDelete(id: Banner['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtrotationdeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtrotationdeletebyid/${id}`);
}
